import tools from './tools'
var env = 'development'
if (process.env.NODE_ENV === 'development') {
    env = 'development'
    
} else if(process.env.NODE_ENV === 'production'){
    env = 'production'
}else {
    if (process.env.VUE_APP_TITLE === 'test') {
        env = 'test'
    }
}

let url = '';
let sourceUrl = '';
let urlImg = ''
let api1 = process.env.VUE_APP_BASE_API1
let api2 = process.env.VUE_APP_BASE_API2

switch (env) {
    case 'development':
        urlImg = url + api2;
        url = url + api1;

        // urlImg = url + '/file';
        // url = url+'/api/mng'
        // url = url+'/mng'
        break
    case 'production':
        url = api1
        sourceUrl = api2
        urlImg = api2
        break
    case 'test':
        url = 'https://repay.balingmedia.com'
        sourceUrl = 'https://repay.balingmedia.com/admin/static/images'
        break
}

url = url+'/mng'
// console.log('url1',url)
// url = url+'/api/mng'   //线上用这个，正式提交代码要改回去***************************************************************




// url='http://58.210.46.6:9981'+'/api/mng'
// urlImg='http://58.210.46.6:9981'
// sourceUrl = 'http://58.210.46.6:9194'
// sourceUrl = 'http://58.210.46.6:9980'


sourceUrl= urlImg +'/api/v1/bgfile/download'

// console.log('sourceUrl',sourceUrl)

let userId =  '*'
// 所有接口
let urlArray = {
    getToken: url + '/dealer/login', // 获取token,登录
    getCaptcha: url + '/dealer/login/gencode', // 获取验证码
    uploadImg: urlImg + '/api/v1/bgfile/upload', // 图片上传，apk文件上传
    uploadFware: urlImg + '/api/v1/bgfile/uploadFware', // 固件文件上传
    forgotPassword: url + '/dealer/forgotPassword', // 忘记密码
    resetPassword: url + '/dealer/resetPassword', // 重置密码


    // 首页
    productsKind: url + '/product/getProductKindCount', // 上市数量
    userCount: url + '/user/getUserCount', // 上市数量
    devicesCount: url + '/device/getDeviceCount', // 设备
    // apps: url + '/app/dealer/'+userId+'/apps', // app
    apps: url + '/app/dealer/getapps', // app，获取app版本的列表
    newMessageNum: url + '/message/getNewMessageCount', // 消息
    pushes: url + '/push/getPushesWithPaging', // 推送
    OnlineNumber: url + '/user/getOnlineCount', // 在线人数
    logCount: url + '/log/getLoginCount', // 当天登录数
    
    //首页 总后台
    homedataList:url+'/main/adminHomedata',//总后台首页子账号列表
    dealerpageList:url+'/dealer/getDealersWithPaging',//总后台首页子账号列表
    addDealer:url+'/dealer/createDealer',//创建子账号
    chooseDealer:url+'/dealer/chooseDealer',//选择的经销商.这个接口后台有做权限控制，普通经销商没法用这个接口
    forceResetPassword:url+'/dealer/forceResetPassword',//选择的经销商.超级管理员才有这个权限


    // common
    usersPassword: url + '/dealer/updateDealerPassword', // 修改密码

    // 产品管理
    productsManageList: url + '/product/getProducts', // 产品列表（产品型号） 全部，产品新增
    productsSet: url + '/product/updateProduct', // 产品编辑
    productsDel: url + '/product/deleteProduct', // 产品删除
    productsAdd: url + '/product/createProduct', // 产品新增
    productsPublish: url + '/product/publishProduct', // 产品发布 mng/products/dealer/{dealerId}/product/{id}/publish
  
    productsGroupList: url + '/product/getProductGroupsOfDealer', // 产品分组 全部，，产品分组新增,删除
    productsGroupAdd: url + '/product/createProductsGroup', // 产品分组新增
    productsGroupSet: url + '/product/updateProductGroupMessage', // 产品分组修改
    productsGroupDel: url + '/product/deleteProductGroup', // 产品分组删除


    typeCateList: url + '/class/getBasicClasses', // 获取某个父类别下面的子类别的列表
    typeList: url + '/basicProduct/getBasicProductsOfBasicClass', // 4.获取一个分类的基础型号/mng/basicProduct/basicProduct/class/{basicClassId}
    functionEdit: url + '/loraKey/updateSelected', // 产品功能定义
    functionList: url + '/loraKey/getOneDealerProductKeys', // 产品功能列表, 增加了一个字段whetherMajor，是否是主要的，true-主要，false-非主要

    basicProductsAdd:url+'/basicProduct/createBasicProduct',//83.创建基础型号
    basicProductsDel:url+'/basicProduct/deleteBasicProduct',//84.删除某个基础型号
    basicProductsSet:url+'/basicProduct/updateBasicProduct',//85.更新一个基础型号
    basicProductsPub:url+'/basicProduct/toPublishBasicProduct',//86.发布一个基础型号

    getBasicKeys:url+'/loraKey/getBasicKeys',//获取一个基础型号对应的键，或者的所有键，，新增一个字段serachMajorKey，获取可以选取主功能的键的时候，多送一个这个字段就行了（送true。其他情况下这个字段可以不送，你送false也等于没有送这个字段）。boolean类型的
    createLoraKey:url+'/loraKey/createLoraKey',//创建lora键
    delBasicKeys:url+'/loraKey/deleteBasicKey',//删除某一个key的定义
    setBasicKeys:url+'/loraKey/modifyBasicKey',//修改lorakey的定义
    excelImportKeys:url+'/loraKey/excelImportKeys',//创建lora键，通过导入excel


    copyBasicProduct:url+'/loraKey/copyTemplateForBasicProduct',//复制现有基础型号的功能

    getProductListFromHyeco:url+'/basicProduct/getProductListFromHyeco',//获取hyeco平台的设备列表
    importHyecoIdentifier:url+'/loraKey/importHyecoIdentifier',//hyeco的指令列表,发送一个加载接口，然后才会有的



    createBasicClasses:url+'/class/createBasicClasses',//创建基础型号分类  className; parentClassId
    modifyBasicClasses:url+'/class/modifyBasicClasses',//修改基础型号分类
    deleteBasicClasses:url+'/class/deleteBasicClasses',//删除基础型号分类


    //   场景模型

    getSceneTemplateOfDealer:url+'/sceneTemplate/getSceneTemplateOfDealer',//获取某经销商的场景模型列表
    createSceneTemplate:url+'/sceneTemplate/createSceneTemplate',//创建场景模型
    modifySceneTemplate:url+'/sceneTemplate/modifySceneTemplate',//修改场景模型
    deleteOneSceneTemplate:url+'/sceneTemplate/deleteOneSceneTemplate',//删除场景模型






    
    
    
    
    // 产品页面
    pagesIdList: url + '/page/getAllPages', // 页面编号(产品页面) 全部
    addPages: url + '/page/createPage', // 总后台创建产品页面
    editPages: url + '/page/updatePage', // 总后台修改产品页面  /mng/pages/page/19
    delPages: url + '/page/deletePage', // 总后台删除产品页面  /mng/pages/page/19

    addOneWordCode: url + '/page/createOneWordCode', // 创建词条
    editOneWordCode: url + '/page/updateOneWordCode', // 修改词条
    delOneWordCode: url + '/page/deleteOneWordCode', // 删除词条

    pagesLangDictionaryList: url + '/page/queryLangDictionaryPage', // 获取词条列表--带分页
    LangPackageDownload: sourceUrl + 'LangPackage', // 词条包下载


    // 控件页面
    addModule:url+'/uimodule/createModule',//新增控件
    editModule:url+'/uimodule/updateModule',//更新控件
    delModule:url+'/uimodule/deleteModule',//删除控件
    getModuleList:url+'/uimodule/getModules',//获取控件列表，获取这个列表的时候，想获取所有请求提就送一个空的{}，如果想过去某种类型的组件就类型的哪个字段对应的值。


   
    //订单管理
    orderShow: url + '/order/getDealerOrders', // 订单列表 分页,新增
    orderAdd: url + '/order/createOrder', //  订单新增
    orderDel: url + '/order/deleteOrder', //  订单删除
    orderdataDetail: url + '/order/getOneOrderDevices', // 详情
    fillOrder: url + '/order/fillOrder', // 实现 mng/order/dealer/10023/fillOrder/326
    orderSet: url + '/order/updateOrder', //  订单修改
    doInstance: url + '/order/doInstance',//实例

    

    //用户管理
    userChart: url + '/user/userChart', // 图表数据
    userGroups: url + '/user/getUserGroups', // 接收用户  全部
    userGroupAdd: url + '/user/createUserGroup', // 新建组织
    userGroupSet: url + '/user/updateUserGroupMessage', // 组织修改
    userGroupDel: url + '/user/deleteUserGroup', // 删除组织
    appUsersList: url + '/user/getAppUsersWithPaging', // 列表 分页
    userEnable: url + '/user/updateUsageStatus', // 用户禁用、解禁
    userGroupListShift: url + '/user/moveUsersGroup', // 移动


    changeAdminMember: url + '/user/changeAdminMember', // 将一个用户关联到到经销商，或者将一个已经关联的解除管理成员。请求参数userId ,adminMember(boolean类型，关联就是true,解除关联就是false)
    getDealerAdminMember: url + '/user/getDealerAdminMember', // 获取经销商管理成员，请求参数{}就行了
    applyJoinFamily: url + '/device/applyJoinFamily', // 经销商管理成员申请加入到设备所在的家，请求参数userId（用户编号）,serialNumber(序列号)




    //登录统计
    logChart: url + '/log/getLogChart', // 图表月份数据
    logsList: url + '/log/getLoginInfoWithPaging', // 登录列表 分页


    //设备管理
    devicesChart: url + '/device/devicesChart', // 图表数据
    devicesList: url + '/device/getDevicesWithPageing', // 设备列表 分页
    deviceGroupsList: url + '/device/getDeviceGroupOfDealer', // 设备列表 分页(无用)，有用作下拉列表选择
    deviceGroupsMove: url + '/device/moveDeviceGroup', // 设备移动组织
    deviceUnbundling: url + '/device/resetDevice', // 设备解绑
    deviceGroupsAdd: url + '/device/createDeviceGroup', // 创建组织
    deviceGroupsSet: url + '/device/updateDeviceGroupMessage', // 修改组织
    deviceGroupsDel: url + '/device/deleteDeviceGroup', // 删除组织
    useInstructionToDevice: url + '/device/useInstructionToDevice', // 发送指令。commandKeyType":5,"commandKey":6,"commandValue":"00.00","loraEUI":"xxx"，如果是吕伟平台的设备只需要吧command这类的，换成identifier:xxxx,identifierValue:xxx就好了

    deviceGroupsMoveDealer:url + '/device/modifyDeviceDealer', // 将这个设备移动到别的经销商下面mng/device/2d7192a1-b66f-4b44-a6b2-db923e61612f/order/212
    getDeviceOneUser:url + '/user/getOneUser', // 获取某一个设备被哪个用户所绑定的用户信息，上送userId就好了

    getDeviceAllAttr:url + '/device/getDeviceAllAttr', // 获取某一个设备的所有指令
    getDeviceRecordAndMessage:url + '/device/getRecordAndMessage', // 获取某一个设备的对应指令的记录或消息的列表.请求参数就是loraEUI   identifier和(commandKey commandKeyType)二选一，loraEUI就是设备的serialNumber必送，后面两个2选一，实现方式是lora的那就是command的那两个，是hyecosmart的就是identifier。这里将会返回给你送的这个指令的记录或消息的列表。然后就是解析出来每一个item的identifierValue和commandValue，直观的展示出来。

    getCanChangeInnerOrdersList:url + '/order/getCanChangeInnerOrders', // 获取设备可以经销商内部转移订单的列表，请求参数serialNumber序列号
    changeInnerOrder:url + '/device/changeInnerOrder', // 将设备转移到同经销商下，同基础型号的其他订单下面，请求参数serialNumber和orderId

    getDeviceChangeDealerLog:url + '/device/deviceChangeDealerLog', // 获取设备移动经销商的日志


    moveInstaller:url + '/device/moveInstaller', // 将一批设备移动到某个安装商下





    // 地图
    getCountOfEachCity: url + '/device/getCountOfEachCity', // 根据国家获取各个城市设备总量
    getDeviceOfOneCity: url + '/device/getDeviceOfOneCity', // 根据城市获取当前城市所有设备列表分布



    // 固件中心
    fwaresList: url + '/fware/getFwaresOfDealer', // 固件列表 分页
    fwaresAdd: url + '/fware/createFware', // 固件新增，post
    fwaresDel: url + '/fware/deleteFware', //  固件删除
    fwareplansList: url + '/fware/getFwarePlans', // 固件计划管理列表 分页,,,分页无效
    fwareplansRun: url + '/fware/updateFwarePlanStatus', // 计划暂停、启动,计划编辑,/mng/fware/dealer/10001/fwareplan/86
    fwareplansEdit: url + '/fware/updateFwarePlan', // 计划编辑,/mng/fware/dealer/10001/fwareplan/86
    fwareplansDel: url + '/fware/deleteFwarePlan', // 计划删除,/mng/fware/dealer/10001/fwareplan/86
    fwareplansAdd: url + '/fware/createFwarePlans', // 计划新增
    fwareDownRecordsList: url + '/fware/getDownRecordsWithPaging', // 固件下载历史列表 分页




    // 应用中心
    apps: url + '/app/getapps', // app列表  有分页
    appsAdd: url + '/app/createApp', // app新增
    appsSet: url + '/app/expireApp', // app版本设置过期 mng/app/10001/app/109
    appPlansList: url + '/app/getAppPlans', // app计划列表  有分页
    appPlansRun: url + '/app/updateAppPlanStatus', //计划暂停、启动
    appPlansEdit: url + '/app/updateAppPlan', //计划编辑,/mng/app/10001/appPlan/36
    appPlansDel: url + '/app/deleteAppPlan', // 计划删除,/mng/app/10001/appPlan/86
    appPlansAdd: url + '/app/createAppPlan', // 计划新增
    appDownRecordsList: url + '/app/getDownRecords', // app下载列表  有分页

    pageVersionAdd: url + '/pageVersion/createPageVersion', // 页面版本 新增
    pageVersionSet: url + '/pageVersion/updatePageVersion', // 页面版本 修改
    pageVersionList: url + '/pageVersion/getPageVersionPage', //页面版本列表  有分页 pageId    versionStatus    os   page(这个是当前需要请求的页数）limit（分页的一夜记录数）
    pageVersionDel: url + '/pageVersion/deletePageVersion', // 页面版本 删除
    pageVersionExpire: url + '/pageVersion/expirePageVersion', // 页面版本 过期

    




    //交易中心
    smsstatisticList: url + '/transaction/getTransSmsStatistic', // 月度短信费用列表  有分页(无用)
    smsesList: url + '/sms/getSmsWithPaging', // 各国费用参考价格列表  有分页
    openSmsStatus: url + '/sms/switchSmsRunStopState', // 各国费用参考价格状态操作
    translogList: url + '/transaction/getTransLogWithPaging', // 充值记录列表  有分页
    translogAdd: url + '/transaction/createTrans', // 充值
    marketPriceSet:url + '/sms/updateSmsPrice', // 60.修改某个国家短信的市场价格

    //反馈信息
    messageGroupList: url + '/message/getMessageGroupsWithPaging', // 反馈信息列表  有分页
    messageGroupInfo: url + '/message/getMessagesOfGroup', // 反馈信息详情
    messageGroupReply: url + '/message/submitFeedBack', // 信息回复

   //推送
   pushesAdd: url + '/push/createPush', // 推送,经销商发送一条推送消息


   //设置
   dealerInfo: url + '/dealer/getDealerBaseMessage', // 查询经销商信息
   dealerInfoSet: url + '/dealer/updateDealerBaseMessage', // 更新经销商信息
   changeApiKey:url + '/dealer/changeApiKey', // 重置密码



   //安装商
   getInstalls: url + '/Installer/getInstalls', // 获取安装商列表
   createInstaller: url + '/Installer/createInstaller', // 新增安装商
   deleteInstaller: url + '/Installer/deleteInstaller', // 删除安装商
   updateInstaller: url + '/Installer/updateInstaller', // 更新安装商的基本信息


   //app引导图
   getAdvertises: url + '/app/getAdvertises', // 获取
   createAdvertise: url + '/app/createAdvertise', // 新增
   deleteAdvertise: url + '/app/deleteAdvertise', // 删除
   updateAdvertise: url + '/app/updateAdvertise', // 更新



    // refreshToken: url + '/system/refresh',// 刷新token
    // adminUrl: url + '/system/bstage', // 获取token
    // captcha: url + '/system/captcha', // 验证码
    // loginOut: url + '/system/logout', // 退出登录

    
    

}
//所有图片路径
let imgArray = {
    logo: sourceUrl + '/logo.png', // logo路径
}

export default { urlArray, imgArray, url, sourceUrl }

